import { useFetchUser } from '@jooxter/core';
import { Navigate, Outlet } from 'react-router';
import { JxtLoader } from '@jooxter/ui';
import { JSX } from 'react';
import { getLandingRoute } from './helpers';

export const OnboardingNotDoneGuard = (): JSX.Element => {
  const { user } = useFetchUser();
  const hasBooking = user?.capabilities?.features?.booking;
  const allowOnboarding = !user?.setupDone && hasBooking;

  if (!user) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <JxtLoader />
      </div>
    );
  }

  return allowOnboarding ? <Outlet /> : <Navigate to={getLandingRoute(!!hasBooking)} replace />;
};
